import { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import DataTable from "react-data-table-component";
import ApiService from "../../../services/api";
import { Link } from "react-router-dom";
import moment from "moment";

const NewsListDashboard = () => {
  const [news, setNews] = useState([]);
  const [Loading, setLoading] = useState(true);

  const fetchNews = async () => {
    const news = await ApiService.getLatestNews();
    setNews(news);
    setLoading(false);
  };

  useEffect(() => {
    fetchNews();
  }, []);

  const columns = [
    {
      name: "Creato il",
      sortable: true,
      selector: (row) => moment(row.date).format("DD-MM-YYYY"),
      center: "true",
      width: "34%",
    },
    {
      name: "Categoria",
      selector: (row) => row.category.name,
      center: "true",
      width: "33%",
    },
    {
      name: "Titolo",
      selector: (row) => row.title,
      center: "true",
      width: "33%",
    },
  ];

  if (Loading) {
    return;
  }

  return <>
      <div className="admin-card">
          <div className="admin-card-header">
              <div className="admin-card-icon admin-card-icon-news black-gradient">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-megaphone-fill" viewBox="0 0 16 16">
                      <path d="M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-11zm-1 .724c-2.067.95-4.539 1.481-7 1.656v6.237a25.222 25.222 0 0 1 1.088.085c2.053.204 4.038.668 5.912 1.56V3.224zm-8 7.841V4.934c-.68.027-1.399.043-2.008.053A2.02 2.02 0 0 0 0 7v2c0 1.106.896 1.996 1.994 2.009a68.14 68.14 0 0 1 .496.008 64 64 0 0 1 1.51.048zm1.39 1.081c.285.021.569.047.85.078l.253 1.69a1 1 0 0 1-.983 1.187h-.548a1 1 0 0 1-.916-.599l-1.314-2.48a65.81 65.81 0 0 1 1.692.064c.327.017.65.037.966.06z"/>
                  </svg>
              </div>
              <p><small>Ultime news</small></p>
          </div>
          <hr className="divider-dark mb-0" />
          <div className="admin-card-content">
            <DataTable columns={columns} data={news} />
              <div className="mb-4 text-end">
                  <a href="/admin/newsList" className="admin-link admin-card-view-more site-link">
                      Visualizza tutti
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
                      </svg>
                  </a>
              </div>
              <Link
                to="/admin/newsCreate"
                className="w-100 btn btn-admin-dashboard-add btn-black-gradient"
                data-discover="true"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  className="bi bi-plus"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                </svg>
                Inserisci Notizia
              </Link>
          </div>
      </div>
  </>
}
export default NewsListDashboard;
